/**
 * Trust-Building Copy & Badge Definitions
 *
 * Centralized trust messaging for the Account Aggregator flow.
 * Used by TrustBadge, TrustBadgeGroup, and PartnerLogos components.
 */

// ============================================================================
// Badge Definitions
// ============================================================================

export interface TrustBadgeDefinition {
  id: string;
  title: string;
  subtitle?: string;
  /** Lucide icon name — resolved by the component */
  icon: "landmark" | "shield-check" | "lock" | "map-pin" | "scan-eye";
  link?: string;
}

export const REGULATORY_BADGES: TrustBadgeDefinition[] = [
  {
    id: "rbi",
    title: "RBI Regulated",
    subtitle: "Account Aggregator Framework",
    icon: "landmark",
    link: "https://sahamati.org.in/what-is-account-aggregator/",
  },
  {
    id: "sebi",
    title: "SEBI Registered",
    subtitle: "Investment Advisor",
    icon: "shield-check",
  },
];

export const SECURITY_BADGES: TrustBadgeDefinition[] = [
  {
    id: "encryption",
    title: "Bank-Grade Security",
    subtitle: "256-bit encryption",
    icon: "lock",
  },
  {
    id: "data-india",
    title: "Data Stays in India",
    subtitle: "Data localization compliant",
    icon: "map-pin",
  },
  {
    id: "no-credentials",
    title: "We Never See Your Password",
    subtitle: "Consent via your bank directly",
    icon: "scan-eye",
  },
];

// ============================================================================
// Partner Definitions
// ============================================================================

export interface PartnerDefinition {
  id: string;
  name: string;
  description: string;
}

export const PARTNERS: PartnerDefinition[] = [
  {
    id: "saafe",
    name: "Saafe",
    description: "RBI-licensed Account Aggregator",
  },
  {
    id: "cams",
    name: "CAMS",
    description: "Registrar & Transfer Agent",
  },
  {
    id: "kfintech",
    name: "KFintech",
    description: "Registrar & Transfer Agent",
  },
];

// ============================================================================
// Trust Messaging
// ============================================================================

export const TRUST_COPY = {
  landing: {
    headline: "Your data, your control",
    body: "Your credentials are never shared with us. The entire consent happens directly with your bank through RBI's secure Account Aggregator framework.",
    revoke: "You can revoke this consent anytime from your Compass settings.",
  },
  consent: {
    headline: "You're in control",
    body: "You can revoke this consent anytime from your Compass settings.",
  },
  postImport: {
    headline: "Secure transfer complete",
    body: "Your portfolio data is encrypted and stored securely in India.",
  },
} as const;
